/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import classNames from 'classnames';
import jump from 'jump.js';
import Img from 'react-image';
import { Link } from '@reach/router';
import { Translation } from 'react-i18next';

import Logo from '../../img/logo_telus.png';
import { history } from '../../utils/router-history';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: 'hidden',
		};
	}

	toggleExpansion = e => {
		const { isExpanded } = this.state;
		e.preventDefault();
		console.log(isExpanded);
		this.setState({
			isExpanded: isExpanded === 'hidden' ? '' : 'hidden',
		});
	};

	navigateTo = section => {
		// debugger;
		console.log({ section });
		if (this.props.page && this.props.page === 'home') {
			jump(`section#${section}`, {
				offset: -90,
				duration: 1000,
			});
		} else {
			this.navigateToHome(section);
		}
	};

	navigateToHome = section => {
		history.navigate('/#' + section, { replace: true });
	};

	render() {
		const { isExpanded } = this.state;
		let headerClass = classNames({
			header: true,
			'fixed bg-white w-full z-30 shadow text-white': true,
		});

		let navMenuClass = classNames({
			'cursor-pointer inline-block text-xl px-2 no-underline py-2 text-telus-purple font-HelveticaNeueLTStd-Roman': true,
		});

		let toggleColourClass = classNames({
			'no-underline hover:no-underline font-bold text-2xl lg:text-4xl': true,
		});

		let navContentClass = classNames({
			'w-full flex-grow lg:flex lg:items-center lg:w-auto lg:block mt-2 lg:mt-0  text-black p-4 lg:p-0 z-20': true,
			[`${isExpanded}`]: true,
		});

		return (
			<nav id='header' className={headerClass}>
				<div className='w-full container mx-auto flex'>
					<div className='pl-4 flex items-center'>
						<a
							className={toggleColourClass}
							onClick={() => history.navigate('/')}
						>
							<Img className='logo z-50' src={Logo} alt='Logo' />
						</a>
					</div>
				</div>
				<div className='w-full container mx-auto flex flex-wrap items-center justify-between mt-0 lg:pb-5'>
					<div className='flex flex-col w-full lg:hidden pr-4 pb-4 self-center'>
						<button
							id='nav-toggle'
							className='flex items-center self-center p-1 hover:border-ccu-green text-telus-purple '
							onClick={this.toggleExpansion}
						>
							<svg
								className='fill-current h-6 w-6'
								viewBox='0 0 20 20'
								xmlns='http://www.w3.org/2000/svg'
							>
								<title>Menu</title>
								<path d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z' />
							</svg>
						</button>
					</div>

					<div className={navContentClass} id='nav-content'>
						<ul className='list-reset lg:flex justify-end flex-1 items-center'>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('about-us')}
								>
									<Translation>
										{t => <p>{t('layout.menu.about')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('join')}
								>
									<Translation>
										{t => <p>{t('layout.menu.join')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('how-to-apply')}
								>
									<Translation>
										{t => <p>{t('layout.menu.how-to-apply')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('benefits')}
								>
									<Translation>
										{t => <p>{t('layout.menu.benefits')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('facilities')}
								>
									<Translation>
										{t => <p>{t('layout.menu.facilities')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => this.navigateTo('values')}
								>
									<Translation>
										{t => <p>{t('layout.menu.values')}</p>}
									</Translation>
								</span>
							</li>
							<li className='mr-2 pointer hidden lg:block'>
								<span className={navMenuClass}>|</span>
							</li>
							<li className='mr-2 pointer'>
								<Link id='navAction' to='/jobs' className={navMenuClass}>
									<Translation>
										{t => <p>{t('layout.menu.opportunities')}</p>}
									</Translation>
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}

export default Header;
